import { rem } from 'polished'
import styled from 'styled-components'

import media from '../../util/media'

export const SocialWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${media.lessThan('md')`
    flex-direction: column;
  `}
`

export const SocialList = styled.ul`
  display: flex;
  align-content: center;

  ${media.lessThan('md')`
    margin-top: 16px;
  `}

  ${media.lessThan('xs')`
    flex-direction: column;
  `}
`

export const SocialItem = styled.li`
  margin-left: 10px;
  margin-right: 10px;

  ${media.lessThan('md')`
    margin-left: 5px;
    margin-right: 5px;
  `}

  ${media.lessThan('xs')`
    margin-left: 0;
    margin-right: 0;

    &:not(:first-of-type) {
      margin-top: 5px;
    }

    &:not(:last-of-type) {
      margin-bottom: 5px;
    }
  `}
`

export const SocialLink = styled.a`
  transition: all 0.5s;
  font-size: ${rem(12)};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.light};
  font-family: ${({ theme }) => theme.font[1]};

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  ${media.lessThan('md')`
    font-size: ${rem(12)};
  `}
`

export const SocialIcon = styled.div`
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.primary};
`
